import { ClassroomType, ClassroomTypesType } from "../../../types/Classroom";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get, post, put } from "../../../utils/axios-config";
import { CLASSROOM, CLASSROOMTYPES } from "../../../utils/constants";


export const createClassRoomType = async (data: ClassroomTypesType) => await post<ClassroomTypesType, string>(CLASSROOMTYPES, data);
export const updateClassRoomType = async (data: ClassroomTypesType) => await put<ClassroomTypesType, string>(CLASSROOMTYPES, data);
export const getClassroomTypes = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${CLASSROOMTYPES}?${queryParams.toString()}`;
    return await get<PagedResultsType<ClassroomTypesType>>(url)
};


export const createClassRoom= async (data: ClassroomType) => await post<ClassroomType, string>(CLASSROOM, data);
export const updateClassRoom= async (data: ClassroomType) => await put<ClassroomType, string>(CLASSROOM, data);
export const getClassroom = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
    });
    const url = `${CLASSROOM}?${queryParams.toString()}`;
    return await get<PagedResultsType<ClassroomType>>(url)
};